module.exports = __webpack_public_path__ + "img/step42_down.19a551de.png";